(function(){'use strict';
function ready(fn){if(document.readyState!=='loading')fn();else document.addEventListener('DOMContentLoaded',fn);}
ready(function(){
/* Scroll reveals */
var reveals=document.querySelectorAll('.rl-reveal');
if('IntersectionObserver' in window && reveals.length){
 var io=new IntersectionObserver(function(entries){entries.forEach(function(e){if(e.isIntersecting){var el=e.target;var delay=el.getAttribute('data-delay')||0;el.style.transitionDelay=delay+'ms';el.classList.add('is-in');io.unobserve(el);}});},{rootMargin:'-80px'});
 reveals.forEach(function(el){io.observe(el);});
}else{reveals.forEach(function(el){el.classList.add('is-in');});}
/* LED showcase */
document.querySelectorAll('[data-rl-led]').forEach(function(root){
 var swatches=root.querySelectorAll('.rl-swatch');
 var env=root.querySelector('.rl-led__env');
 var tint=root.querySelector('.rl-product__tint');
 var halo=root.querySelector('.rl-product__halo');
 var nameEl=root.querySelector('[data-led-name]');
 var dotEl=root.querySelector('[data-led-dot]');
 var benefitEl=root.querySelector('[data-led-benefit]');
 var descEl=root.querySelector('[data-led-desc]');
 function select(btn){
  swatches.forEach(function(s){s.setAttribute('aria-pressed','false');});
  btn.setAttribute('aria-pressed','true');
  var color=btn.getAttribute('data-color');var glow=btn.getAttribute('data-glow');
  if(env)env.style.background='radial-gradient(900px 600px at 50% 35%, '+glow+', transparent 65%)';
  if(tint){tint.style.background=color;tint.style.opacity='0.42';}
  if(halo)halo.style.background=glow;
  if(nameEl)nameEl.textContent=btn.getAttribute('data-name');
  if(dotEl){dotEl.style.background=color;dotEl.style.boxShadow='0 0 12px '+glow;}
  if(benefitEl)benefitEl.textContent=btn.getAttribute('data-benefit');
  if(descEl)descEl.textContent=btn.getAttribute('data-desc');
 }
 swatches.forEach(function(btn){btn.addEventListener('click',function(){select(btn);});});
 if(swatches[0])select(swatches[0]);
});
/* Before/After slider */
document.querySelectorAll('[data-rl-ba]').forEach(function(root){
 var before=root.querySelector('.rl-ba__before');
 var handle=root.querySelector('.rl-ba__handle');
 var grip=root.querySelector('.rl-ba__grip');
 var dragging=false;
 function setPos(clientX){
  var rect=root.getBoundingClientRect();
  var pct=Math.min(100,Math.max(0,((clientX-rect.left)/rect.width)*100));
  before.style.clipPath='inset(0 '+(100-pct)+'% 0 0)';
  handle.style.left=pct+'%';
  if(grip)grip.setAttribute('aria-valuenow',Math.round(pct));
 }
 setPos(root.getBoundingClientRect().left+root.getBoundingClientRect().width/2);
 root.addEventListener('pointerdown',function(e){dragging=true;root.setPointerCapture(e.pointerId);setPos(e.clientX);});
 root.addEventListener('pointermove',function(e){if(dragging)setPos(e.clientX);});
 root.addEventListener('pointerup',function(){dragging=false;});
 if(grip)grip.addEventListener('keydown',function(e){var rect=root.getBoundingClientRect();var cur=parseFloat(grip.getAttribute('aria-valuenow')||50);if(e.key==='ArrowLeft')setPos(rect.left+rect.width*Math.max(0,cur-4)/100);if(e.key==='ArrowRight')setPos(rect.left+rect.width*Math.min(100,cur+4)/100);});
});
/* FAQ */
document.querySelectorAll('.rl-faq__item').forEach(function(item){
 var q=item.querySelector('.rl-faq__q');var a=item.querySelector('.rl-faq__a');
 q.addEventListener('click',function(){var open=item.classList.toggle('is-open');q.setAttribute('aria-expanded',open?'true':'false');a.style.maxHeight=open?a.scrollHeight+'px':'0px';});
});
/* Sticky bar */
var sticky=document.querySelector('[data-rl-sticky]');
if(sticky){var onScroll=function(){if(window.scrollY>window.innerHeight*0.9)sticky.classList.add('is-shown');else sticky.classList.remove('is-shown');};window.addEventListener('scroll',onScroll,{passive:true});onScroll();}
/* Add to cart (AJAX) */
document.querySelectorAll('[data-rl-add]').forEach(function(form){
 form.addEventListener('submit',function(e){
  if(!window.fetch)return;
  e.preventDefault();
  var btn=form.querySelector('[type="submit"]');var original=btn?btn.innerHTML:'';
  if(btn){btn.disabled=true;btn.innerHTML='Adding…';}
  var data=new FormData(form);
  var root=(window.Shopify&&window.Shopify.routes)?window.Shopify.routes.root:'/';
  fetch(root+'cart/add.js',{method:'POST',headers:{'Accept':'application/json'},body:data}).then(function(r){return r.json();}).then(function(){
   if(btn)btn.innerHTML='Added ✓';
   var drawer=document.querySelector('cart-drawer');
   if(drawer&&typeof drawer.open==='function'){
    fetch(root+'?section_id=cart-drawer').then(function(res){return res.text();}).then(function(text){try{var html=new DOMParser().parseFromString(text,'text/html');var ni=html.querySelector('cart-drawer');if(ni)drawer.innerHTML=ni.innerHTML;}catch(err){}drawer.classList.remove('is-empty');drawer.open();if(btn){btn.disabled=false;btn.innerHTML=original;}});
   }else{window.location.href=root+'cart';}
  }).catch(function(){form.submit();});
 });
});
});
})();